// Brushed-metal light for the voucher card (ported from the design's MC-JS).
// Pure data: shader sources + the silver finish.

export const METAL_VS =
  'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';

export const METAL_FS = `precision highp float;
uniform vec2 uRes;uniform float uDpr;uniform vec3 uDark,uMid,uLight;uniform float uFringe,uStrength,uQ0,uLine,uEdgeS,uRim,uGrain;uniform vec3 uEdgeC;uniform vec2 uTilt;uniform float uHolo;uniform float uBevel;uniform float uSw,uSa;
float sdRB(vec2 p,vec2 b,float r){vec2 q=abs(p)-b+r;return length(max(q,0.))+min(max(q.x,q.y),0.)-r;}

float prof(float x,float w){return (0.66*exp(-pow(x/w,2.))+0.26*exp(-pow(x/(w*2.6),2.))+0.08*exp(-pow(x/(w*5.),2.)));}
float hash(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233)))*43758.5453);}
void main(){
 vec2 fc=vec2(gl_FragCoord.x,uRes.y-gl_FragCoord.y);
 vec2 uv=fc/uRes; vec2 p=(uv-.5)*vec2(uRes.x/uRes.y,1.);
 float ang=radians(-27.+uTilt.x*9.-uTilt.y*5.); vec2 dir=vec2(cos(ang),sin(ang)); vec2 nrm=vec2(-dir.y,dir.x);
 float q=dot(p,nrm), along=dot(p,dir);
 float qs=uQ0+uTilt.x*0.42+uTilt.y*0.14; float qb=qs+uSw;
 
 float s1=smoothstep(-0.75,qs,q), s2=smoothstep(qs+0.02,0.62,q);
 vec3 col=mix(uMid,uLight,s1*0.55); col=mix(col,uDark,s2*0.88);
 col*=1.0+0.05*sin(along*2.2);
 
 float w=0.095*(1.+0.4*uHolo), dsp=0.022*uFringe;
 float bR=prof(q-qb-dsp,w), bG=prof(q-qb,w), bB=prof(q-qb+dsp,w);
 float mod=0.8+0.2*sin(along*3.1+0.6);
 vec3 band=vec3(bR*1.0,bG*0.92,bB*1.0);
 col+=band*uStrength*mod*uSa;
 float glow=exp(-pow((q-qb)/(w*3.8*(1.+0.45*uHolo)),2.));
 col+=glow*uStrength*0.2*uLight*uSa;
 float glow2=exp(-pow((q-qb-0.34)/0.2,2.));col+=glow2*uStrength*0.07*uLight*uSa;
 
 if(uHolo>0.001){
  float ph=(q-qs)*1.5+along*0.35+uTilt.x*0.9+uTilt.y*0.5;
  vec3 hue=0.5+0.5*cos(6.2832*(ph+vec3(0.0,0.33,0.67)));
  float zone=exp(-pow((q-qs)/(0.45+0.75*uHolo),2.))*0.9;
  col=mix(col,col*0.55+hue*0.6*mix(vec3(1.),uLight,.45),uHolo*zone*0.13);
  col+=hue*uHolo*zone*0.015;
 }
 
 if(uLine>0.5){
  float pitch=2.0*uDpr; float tt;
  if(uLine<1.5) tt=fc.x/pitch; else if(uLine<2.5) tt=fc.y/pitch; else tt=(fc.x+fc.y)*0.70711/pitch;
  float f=fract(tt);
  float ridge=smoothstep(0.0,0.28,f)*(1.-smoothstep(0.3,0.58,f));
  float groove=smoothstep(0.55,0.78,f)*(1.-smoothstep(0.84,1.0,f));
  float bm=clamp(bG*1.1+glow*0.9,0.,1.);
  col*=1.0-0.07*groove;
  col+=uLight*0.055*ridge*(0.35+0.9*bm);
 }
 
 vec2 px=fc-uRes*.5, hs=uRes*.5; float r=uRes.x*.035; float d=sdRB(px,hs,r);
 vec2 e=vec2(1.,0.);
 vec2 n=normalize(vec2(sdRB(px+e,hs,r)-sdRB(px-e,hs,r),sdRB(px+e.yx,hs,r)-sdRB(px-e.yx,hs,r))+1e-5);
 float lit=clamp(dot(n,normalize(vec2(-1.-uTilt.x*1.1,-1.-uTilt.y*1.1)))*.5+.5,0.,1.);
 float edge=smoothstep(-1.5*uDpr,-1.0*uDpr,d)*(1.-smoothstep(-0.4*uDpr,0.2*uDpr,d));
 float bn=exp(-pow((q-qb)/(0.3+0.25*uHolo),2.));
 col+=edge*pow(lit,1.6)*uEdgeC*uEdgeS*mix(1.,0.3+1.0*bn,uHolo)*(1.-.8*uBevel);
 if(uHolo>0.001){vec3 eh=0.5+0.5*cos(6.2832*(dot(n,vec2(.7,.7))*.6+uTilt.x*.5+vec3(0.,.33,.67)));col+=edge*pow(lit,2.2)*eh*uHolo*0.12*bn;}

 col=mix(col,col*0.62,edge*(1.-lit)*0.7*(1.-0.6*uHolo));
 
 float g=(hash(fc)*0.78+hash(floor(fc/uDpr)+17.3)*0.22)-0.5;
 col*=1.0+g*uGrain;
 float alpha=1.;
 if(uBevel>.5){
  
  float bw=max(2.2*uDpr,uRes.x*.0042);
  float tb=clamp((d+bw)/bw,0.,1.);
  float L2=clamp(dot(n,normalize(vec2(-.55,-1.)))*.5+.5,0.,1.);
  vec3 bhi=col*1.1+uEdgeC*.07, blo=col*.58;
  vec3 bev=mix(blo,bhi,smoothstep(.2,.85,L2));
  float bz=smoothstep(0.,.55,tb)*(1.-smoothstep(-.2*uDpr,.35*uDpr,d));
  col=mix(col,bev,bz*.92);
  float hair=smoothstep(-1.5*uDpr,-.9*uDpr,d)*(1.-smoothstep(-.55*uDpr,0.,d));
  col+=hair*pow(L2,2.4)*uEdgeC*.3;
  col*=1.-hair*(1.-L2)*.3;
  alpha=1.-smoothstep(-.75*uDpr,.45*uDpr,d);
 }
 col+=(hash(fc+3.1)-.5)/255.;
 gl_FragColor=vec4(clamp(col,0.,1.),alpha);
}`;

export const SILVER = {
  dark: [0.5, 0.51, 0.55],
  mid: [0.73, 0.74, 0.77],
  light: [0.91, 0.91, 0.94],
  fringe: 1.4,
  strength: 0.2,
  q0: -0.02,
  edgeColor: [1.0, 1.0, 1.0],
  edgeStrength: 0.9,
  rim: 0,
  grain: 0.03,
} as const;
